<div class="bottom-sheet-overlay embedded-mode" (click)="closePopup()">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="detail-scroll-container">
      <!-- White header band (cover + fleet info) -->
      <div class="fleet-header-band">
        <div class="fleet-header-inner">
          <!-- Cover Section -->
          <div class="cover-section">
            <img
              [src]="
                fleet?.cover_photo_url
                  ? fleet.cover_photo_url
                  : 'assets/home/profile/banner_profile.webp'
              "
              class="cover-placeholder"
            />

            <div class="cover-overlay" *ngIf="updatingCover">
              <app-loader></app-loader>
            </div>

            <app-back-button
              class="back-btn-overlay"
              ariaLabel="Close fleet"
              (clicked)="closePopup()"
            ></app-back-button>

            <app-edit-button
              *ngIf="fleet?.my_role === 'owner'"
              class="edit-btn-overlay"
              ariaLabel="Edit fleet"
              (clicked)="openEditFleet()"
            ></app-edit-button>

            <!-- Profile Image -->
            <div class="profile-img-container">
              <img
                *ngIf="fleet?.image_url"
                [src]="fleet.image_url"
                class="profile-img"
              />
              <div *ngIf="!fleet?.image_url" class="profile-placeholder">
                {{ getInitials(fleet?.name) }}
              </div>
              <div class="profile-loader-overlay" *ngIf="updatingPic">
                <app-loader></app-loader>
              </div>
              <input
                type="file"
                #picInput
                hidden
                (change)="onFileSelected($event, 'pic')"
                accept="image/*"
              />
              <app-camera-button
                *ngIf="fleet?.my_role === 'owner'"
                variant="profile"
                ariaLabel="Update fleet photo"
                (clicked)="triggerUpdate('pic')"
              ></app-camera-button>
            </div>

            <div
              class="cover-camera-wrapper"
              *ngIf="fleet?.my_role === 'owner'"
            >
              <input
                type="file"
                #coverInput
                hidden
                (change)="onFileSelected($event, 'cover')"
                accept="image/*"
              />
              <app-camera-button
                variant="cover"
                ariaLabel="Update cover photo"
                (clicked)="triggerUpdate('cover')"
              ></app-camera-button>
            </div>
          </div>

          <!-- Content Section -->
          <div class="content-section">
            <div class="header-info">
              <span class="created-at">Created by {{ createdDate }}</span>
              <!-- <span class="owner-name">• Captain
            {{ fleet?.owner_name || fleet?.admin_name || "Admin" }}</span> -->
            </div>

            <h2 class="fleet-title">{{ fleet?.name }}</h2>

            <div class="fleet-meta-row">
              <!-- Left column: captain / location / members -->
              <div class="fleet-meta-left">
                <div class="subheader-info">
                  <!-- Blue, but NOT a link — parity with the app, where this is a
                       plain `Text` widget in `fleet_details_screen.dart`
                       ("Captain ${fleet.ownerName}", colour 0xFF007AFF) with no
                       GestureDetector around it. `FleetModel` carries no owner id
                       at all, so the app has nothing to navigate to either.
                       The clickable element in this header is the member count,
                       which opens the roster — same as the app. -->
                  <span class="owner-name"
                    >Captain
                    {{
                      fleet?.owner_name || fleet?.admin_name || "Admin"
                    }}</span
                  >
                  <!-- Home port exactly as stored — the app renders `fleet.homePort`
                       verbatim and drops the row (and the bullet) when it's blank.
                       The web used to append a hard-coded ", NJ" plus a
                       "Point Pleasant" placeholder to every fleet. -->
                  <p class="location" *ngIf="fleetHomePort">
                    • {{ fleetHomePort }}
                  </p>
                </div>
                <p
                  class="member-count-link member-count-link--clickable"
                  (click)="openMemberList()"
                >
                  {{ fleet?.members_count }}
                  {{ fleet?.members_count <= 1 ? "member" : "members" }}
                </p>
              </div>

              <!-- Right column: category -->
              <div class="fleet-meta-right">
                <div class="fleet-category-tag" *ngIf="fleet?.category">
                  <img
                    [src]="getCategoryIcon(fleet.category)"
                    class="category-icon"
                    *ngIf="getCategoryIcon(fleet.category)"
                  />
                  <span>{{ fleet.category | titlecase }}</span>
                </div>
              </div>
            </div>

            <!-- Fleet Description -->
            <div
              class="fleet-description-block"
            >
              <p
                #fleetDescriptionText
                class="fleet-description"
                [class.fleet-description--expanded]="isDescriptionExpanded"
              >
                {{ fleet?.description || "A new fleet" }}
              </p>
              <button
                type="button"
                class="fleet-description-toggle"
                *ngIf="canToggleDescription"
                (click)="toggleDescription()"
              >
                {{ isDescriptionExpanded ? "Show less" : "Show more" }}
              </button>
            </div>

            <!-- Restriction Rules card (only for restrictive fleets) -->
            <div class="restriction-rules-card" *ngIf="fleet?.is_restrictive">
              <div
                class="rr-header"
                (click)="showRestrictionRulesDialog = !showRestrictionRulesDialog"
              >
                <div class="rr-left">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#0A84FF"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                    ></path>
                  </svg>
                  <span>Restriction Rules</span>
                </div>
                 <button
                type="button"
                class="fleet-description-toggle"
                [class.open]="showRestrictionRulesDialog"
              >
                {{ showRestrictionRulesDialog ? "Show less" : "Show more" }}
              </button>
                <!-- <span [class.open]="showRestrictionRulesDialog">See More</span> -->
               
              </div>

              <div class="rr-body" [class.open]="showRestrictionRulesDialog">
                <div class="rr-body-inner">
                  <span class="dialog-title">Sharing restrictions apply</span>
                  <div class="info-banner">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#0A84FF"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      style="flex-shrink: 0"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="12"></line>
                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                    <span>These restrictions help keep shared fleet content contained.</span>
                  </div>

                  <div class="rule-card">
                    <div class="rule-number">1</div>
                    <p class="rule-text">
                      Content shared within this group cannot be shared outside
                      the group. A user can still set it as private.
                    </p>
                  </div>

                  <div class="rule-card">
                    <div class="rule-number">2</div>
                    <p class="rule-text">
                      If a user shares content outside this group while this
                      feature is enabled, the user will lose access to this
                      group's data.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Fleet Activity Card — non-members only, exactly like the app
                 (`if (!isMember && !isOwner)` in fleet_details_screen.dart).
                 Members already get the full Activity feed lower down, so
                 rendering this too left a tall, mostly-empty stats card above it. -->
            <div class="activity-card" *ngIf="!hideActivity && !isFleetMember">
              <h3>Fleet Activity</h3>
              <div class="stats-grid">
                <div class="stat-item">
                  <span class="stat-label">Routes</span>
                  <span class="stat-value">{{
                    fleet?.activity?.routes || 0
                  }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Fish Caught</span>
                  <span class="stat-value">{{
                    fleet?.activity?.fish_caught || 0
                  }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Bait Mark</span>
                  <span class="stat-value">{{
                    fleet?.activity?.places || 0
                  }}</span>
                </div>
              </div>
            </div>

            <!-- Private Fleet info (if applicable) + the fleet action button.
                 The lock block stays centred (as in the app), but the action
                 button is a full-width block so it lines up with the cards
                 above it instead of floating in the middle of the sheet. -->
            <div
              class="private-info"

            >
              <div class="lock-icon-container"  *ngIf="
                fleet?.privacy === 'private' &&
                fleet?.request_status !== 'accepted'
              ">
                <img src="assets/common_icons/lock_btn.svg" alt="Private" />
              </div>
              <h3  *ngIf="
                fleet?.privacy === 'private' &&
                fleet?.request_status !== 'accepted'
              " class="private-label">Private Fleet</h3>
              <p  *ngIf="
                fleet?.privacy === 'private' &&
                fleet?.request_status !== 'accepted'
              " class="private-desc">
                Join requests must be approved to view other fleet activity.
              </p>

             <!-- Members (not owner): Leave Fleet — mirrors Flutter isMember && !isOwner -->
             <button
  *ngIf="fleet?.request_status === 'accepted' && fleet?.my_role !== 'owner'"
  class="request-join-btn leave"
  [appTourAnchor]="'fleet_details.action_button'"
  [disabled]="requesting"
  (click)="leaveFleet()"
>
  <span *ngIf="requesting" class="btn-spinner"></span>
  <span *ngIf="!requesting">Leave Fleet</span>
</button>

             <!-- Non-members: Request To Join / Request Sent -->
             <button
  *ngIf="fleet?.request_status !== 'incoming' && fleet?.request_status !== 'accepted'"
  class="request-join-btn"
  [appTourAnchor]="'fleet_details.action_button'"
  [disabled]="requesting || fleet?.request_status === 'pending'"
  (click)="requestToJoin()"
>
  <span *ngIf="requesting" class="btn-spinner"></span>
  <span *ngIf="!requesting">{{
    fleet?.request_status === 'pending' ? 'Request Sent' : 'Request To Join'
  }}</span>
</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Grey content band (activity) -->
      <div class="fleet-content-band">
        <div class="fleet-content-inner">
          <div
            class="fleet-activity-tabs"
            *ngIf="fleet?.request_status === 'accepted'"
          >
            <div class="tabs-navigation">
              <button class="tab-btn" [class.active]="true">Activity</button>
            </div>
          </div>

          <!-- Shared Posts List -->
          <div
            class="shared-posts-list"
            *ngIf="fleet?.request_status === 'accepted'" 
          >
            <app-loader *ngIf="checkingRestrictiveAccess"></app-loader>

            <!-- Access Removed: non-owner member has active trip shared outside this fleet -->
            <div
              *ngIf="!checkingRestrictiveAccess && restrictiveAccessRemoved"
              class="restrictive-access-removed"
            >
              <span class="rar-title">Access Removed</span>
              <span class="rar-subtitle"
                >Posts not available while sharing outside of this fleet.</span
              >
            </div>

            <ng-container
              *ngIf="!checkingRestrictiveAccess && !restrictiveAccessRemoved"
            >
              <!-- Skeleton loader while posts are loading -->
              <div class="waypoint-skeleton" *ngIf="loadingPosts">
                <div class="skeleton-card" *ngFor="let i of [1,2,3]">
                  <div class="skeleton-header">
                    <div class="skeleton-avatar"></div>
                    <div class="skeleton-text-group">
                      <div class="skeleton-line short"></div>
                      <div class="skeleton-line x-short"></div>
                    </div>
                    <div class="skeleton-badge"></div>
                  </div>
                  <div class="skeleton-wp-body">
                    <div class="skeleton-wp-content">
                      <div class="skeleton-line medium"></div>
                      <div class="skeleton-line short"></div>
                      <div class="skeleton-stats-grid">
                        <div class="skeleton-rect skeleton-stat-cell" *ngFor="let s of [1,2,3,4]"></div>
                      </div>
                    </div>
                    <div class="skeleton-rect skeleton-wp-map"></div>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="!loadingPosts">
              <ng-container *ngFor="let post of visiblePosts">
                <!-- ── MEMBER JOINED CARD ── -->
                <div class="member-joined-card" *ngIf="isMemberPost(post)">
                  <div class="mj-header-row">
                    <div class="mj-type-info">
                      <div class="mj-icon-circle">
                        <mat-icon class="mj-wave-mat-icon"
                          >waving_hand</mat-icon
                        >
                      </div>
                      <span class="mj-type-text">{{
                        post.content?.headline || "New Fleet Member"
                      }}</span>
                    </div>
                    <span class="mj-time">{{
                      getRelativeTime(
                        post.audit_data?.create_ts ||
                          post.audit_data?.created_at
                      )
                    }}</span>
                  </div>
                  <div class="mj-body-row">
                    <img
                      *ngIf="post.source_profile?.image_url"
                      [src]="post.source_profile.image_url"
                      class="mj-avatar"
                    />
                    <div
                      *ngIf="!post.source_profile?.image_url"
                      class="mj-avatar mj-avatar-initials"
                    >
                      {{ getInitials(post.source_profile?.name) }}
                    </div>
                    <div class="mj-person-info">
                      <span class="mj-person-name">{{
                        post.source_profile?.name || "A new member"
                      }}</span>
                      <span class="mj-person-desc">{{
                        post.content?.text ||
                          (post.source_profile?.name || "A new member") +
                            " just joined the fleet!"
                      }}</span>
                    </div>
                  </div>
                </div>

                <!-- ── POST CARD ── -->
                <div class="waypoint-card post-card" *ngIf="isTextPost(post)">
                  <!-- Author header (avatar + name + time + privacy badge) -->
                  <div class="wp-user-header">
                    <img
                      *ngIf="getAuthorAvatar(post)"
                      [src]="getAuthorAvatar(post)"
                      class="wp-user-avatar clickable"
                      alt="Author avatar"
                      (click)="onPostAvatarClick(post, $event)"
                      (error)="onImageError($event)"
                    />
                    <div
                      *ngIf="!getAuthorAvatar(post)"
                      class="wp-user-avatar avatar-initials clickable"
                      (click)="onPostAvatarClick(post, $event)"
                    >
                      {{ getAuthorInitials(post) }}
                    </div>
                    <div class="wp-user-text clickable" (click)="onPostAvatarClick(post, $event)">
                      <span class="wp-user-name">{{ getAuthorName(post) }}</span>
                      <span class="wp-user-time">
                        {{ getRelativeTime(post.audit_data?.create_ts || post.created_at || post.create_ts) }}
                      </span>
                    </div>

                    <div class="privacy-badge" [ngClass]="getBadgeType(post)">
                      <svg *ngIf="getBadgeType(post) === 'public'" viewBox="0 0 24 24" fill="none" width="14" height="14"
                        stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="9"></circle>
                        <path d="M3.6 9h16.8"></path>
                        <path d="M3.6 15h16.8"></path>
                        <path d="M12 3c2.2 2.3 3.4 5.5 3.4 9S14.2 18.7 12 21"></path>
                        <path d="M12 3c-2.2 2.3-3.4 5.5-3.4 9s1.2 6.7 3.4 9"></path>
                      </svg>
                      <svg *ngIf="getBadgeType(post) === 'private'" viewBox="0 0 24 24" fill="none" width="14" height="14"
                        stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="5" y="10" width="14" height="10" rx="2"></rect>
                        <path d="M8 10V7.8C8 5.7 9.8 4 12 4s4 1.7 4 3.8V10"></path>
                        <circle cx="12" cy="15" r="1.2" fill="currentColor" stroke="none"></circle>
                      </svg>
                      <svg *ngIf="getBadgeType(post) === 'custom' || getBadgeType(post) === 'shared'" viewBox="0 0 24 24" fill="none"
                        width="14" height="14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                        stroke-linejoin="round">
                        <circle cx="9" cy="9" r="2.5"></circle>
                        <circle cx="16.5" cy="8" r="2"></circle>
                        <path d="M5.5 18.5c.6-2.4 2.4-3.8 5-3.8s4.4 1.4 5 3.8"></path>
                        <path d="M15 15.2c1.7.1 2.9 1.1 3.5 3.3"></path>
                      </svg>
                      <span>{{ getBadgeLabel(post) }}</span>
                    </div>
                  </div>

                  <!-- Top divider line below header -->
                  <div class="divider"></div>

                  <div class="post-body-wrap">
                    <p class="post-text-content" *ngIf="getPostText(post)">
                      {{ getPostText(post) }}
                    </p>

                    <!-- Attached Images (if any) -->
                    <div class="post-media" *ngIf="getPostImages(post).length > 0">
                      <div
                        class="single-image-wrap"
                        *ngIf="getPostImages(post).length === 1"
                        (click)="openPhotoLightbox(post, getPostImages(post)[0], $event)"
                      >
                        <img
                          [src]="getPostImages(post)[0]"
                          alt="Post photo"
                          class="post-photo-single clickable"
                          loading="lazy"
                          (error)="onImageError($event)"
                        />
                      </div>

                      <div
                        class="multi-images-grid"
                        *ngIf="getPostImages(post).length > 1"
                      >
                        <div
                          class="multi-image-item"
                          *ngFor="let img of getPostImages(post) | slice:0:4; let idx = index"
                          (click)="openPhotoLightbox(post, img, $event)"
                        >
                          <img [src]="img" alt="Post photo" class="post-photo-thumb clickable" loading="lazy" (error)="onImageError($event)" />
                          <div class="more-images-overlay" *ngIf="idx === 3 && getPostImages(post).length > 4">
                            +{{ getPostImages(post).length - 4 }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Bottom divider line above interaction bar -->
                  <div class="divider interaction-divider"></div>

                  <div (click)="$event.stopPropagation()">
                    <app-post-interaction-bar
                      [postId]="getPostId(post)"
                      postType="waypoint"
                      [initialReactions]="post.reactions"
                      [initialCommentsCount]="getPostCommentsCount(post)"
                      [enableInteractions]="true"
                    >
                      <button
                        class="action-btn"
                        *ngIf="canEditPost(post)"
                        title="Edit post"
                        (click)="$event.stopPropagation(); openWaypointDetail(post)"
                      >
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                        </svg>
                      </button>
                    </app-post-interaction-bar>
                  </div>
                </div>

                <!-- ── PHOTO CARD ── -->
                <div class="waypoint-card photo-card" *ngIf="isPhotoPost(post) && !isTextPost(post)">
                  <!-- Author header (avatar + name + time + privacy badge) -->
                  <div class="wp-user-header">
                    <img
                      *ngIf="getAuthorAvatar(post)"
                      [src]="getAuthorAvatar(post)"
                      class="wp-user-avatar clickable"
                      alt="Author avatar"
                      (click)="onPostAvatarClick(post, $event)"
                      (error)="onImageError($event)"
                    />
                    <div
                      *ngIf="!getAuthorAvatar(post)"
                      class="wp-user-avatar avatar-initials clickable"
                      (click)="onPostAvatarClick(post, $event)"
                    >
                      {{ getAuthorInitials(post) }}
                    </div>
                    <div class="wp-user-text clickable" (click)="onPostAvatarClick(post, $event)">
                      <span class="wp-user-name">{{ getAuthorName(post) }}</span>
                      <span class="wp-user-time">
                        {{ getRelativeTime(post.audit_data?.create_ts || post.created_at || post.create_ts) }}
                      </span>
                    </div>

                    <div class="privacy-badge" [ngClass]="getBadgeType(post)">
                      <svg *ngIf="getBadgeType(post) === 'public'" viewBox="0 0 24 24" fill="none" width="14" height="14"
                        stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="9"></circle>
                        <path d="M3.6 9h16.8"></path>
                        <path d="M3.6 15h16.8"></path>
                        <path d="M12 3c2.2 2.3 3.4 5.5 3.4 9S14.2 18.7 12 21"></path>
                        <path d="M12 3c-2.2 2.3-3.4 5.5-3.4 9s1.2 6.7 3.4 9"></path>
                      </svg>
                      <svg *ngIf="getBadgeType(post) === 'private'" viewBox="0 0 24 24" fill="none" width="14" height="14"
                        stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="5" y="10" width="14" height="10" rx="2"></rect>
                        <path d="M8 10V7.8C8 5.7 9.8 4 12 4s4 1.7 4 3.8V10"></path>
                        <circle cx="12" cy="15" r="1.2" fill="currentColor" stroke="none"></circle>
                      </svg>
                      <svg *ngIf="getBadgeType(post) === 'custom' || getBadgeType(post) === 'shared'" viewBox="0 0 24 24" fill="none"
                        width="14" height="14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                        stroke-linejoin="round">
                        <circle cx="9" cy="9" r="2.5"></circle>
                        <circle cx="16.5" cy="8" r="2"></circle>
                        <path d="M5.5 18.5c.6-2.4 2.4-3.8 5-3.8s4.4 1.4 5 3.8"></path>
                        <path d="M15 15.2c1.7.1 2.9 1.1 3.5 3.3"></path>
                      </svg>
                      <span>{{ getBadgeLabel(post) }}</span>
                    </div>
                  </div>

                  <!-- Top divider line below header -->
                  <div class="divider"></div>

                  <div class="watch-photo-card-body">
                    <!-- Full-bleed photo gallery matching mobile _PhotoStackedPhotoGrid -->
                    <div class="watch-photo-fullbleed-wrap" *ngIf="getPostImages(post) as photoImgs">
                      <!-- 1 image: 4:3 aspect ratio full bleed -->
                      <div
                        class="photo-grid-single"
                        *ngIf="photoImgs.length === 1"
                        (click)="openPhotoLightbox(post, photoImgs[0], $event)"
                      >
                        <img
                          [src]="photoImgs[0]"
                          alt="Photo post"
                          class="full-bleed-photo clickable"
                          loading="lazy"
                          (error)="onImageError($event)"
                        />
                      </div>

                      <!-- 2 images: 16:10 duo equal columns -->
                      <div
                        class="photo-grid-duo"
                        *ngIf="photoImgs.length === 2"
                      >
                        <div
                          class="photo-cell"
                          *ngFor="let img of photoImgs"
                          (click)="openPhotoLightbox(post, img, $event)"
                        >
                          <img
                            [src]="img"
                            alt="Photo post"
                            class="full-bleed-photo clickable"
                            loading="lazy"
                            (error)="onImageError($event)"
                          />
                        </div>
                      </div>

                      <!-- 3+ images: 16:10 lead (flex 3) + stacked (flex 2) -->
                      <div
                        class="photo-grid-stacked"
                        *ngIf="photoImgs.length >= 3"
                      >
                        <div
                          class="photo-cell-lead"
                          (click)="openPhotoLightbox(post, photoImgs[0], $event)"
                        >
                          <img
                            [src]="photoImgs[0]"
                            alt="Photo post"
                            class="full-bleed-photo clickable"
                            loading="lazy"
                            (error)="onImageError($event)"
                          />
                        </div>
                        <div class="photo-cells-stack">
                          <div
                            class="photo-cell-sub"
                            (click)="openPhotoLightbox(post, photoImgs[1], $event)"
                          >
                            <img
                              [src]="photoImgs[1]"
                              alt="Photo post"
                              class="full-bleed-photo clickable"
                              loading="lazy"
                              (error)="onImageError($event)"
                            />
                          </div>
                          <div
                            class="photo-cell-sub"
                            (click)="openPhotoLightbox(post, photoImgs[2], $event)"
                          >
                            <img
                              [src]="photoImgs[2]"
                              alt="Photo post"
                              class="full-bleed-photo clickable"
                              loading="lazy"
                              (error)="onImageError($event)"
                            />
                            <div class="photo-more-badge" *ngIf="photoImgs.length > 3">
                              +{{ photoImgs.length - 3 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Divider & Interaction Bar below the photo -->
                    <div class="divider interaction-divider"></div>

                    <div (click)="$event.stopPropagation()">
                      <app-post-interaction-bar
                        [postId]="getPostId(post)"
                        postType="waypoint"
                        [initialReactions]="post.reactions"
                        [initialCommentsCount]="getPostCommentsCount(post)"
                        [enableInteractions]="true"
                      >
                        <button
                          class="action-btn"
                          *ngIf="canEditPost(post)"
                          title="Edit photo"
                          (click)="$event.stopPropagation(); openWaypointDetail(post)"
                        >
                          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                          </svg>
                        </button>
                      </app-post-interaction-bar>
                    </div>

                    <!-- Caption below interaction bar -->
                    <div class="watch-photo-caption" *ngIf="getPostCaption(post)">
                      <p class="caption-text">{{ getPostCaption(post) }}</p>
                    </div>

                    <!-- Muted coordinates footnote (only if valid coords and not N/A) -->
                    <div class="watch-photo-coords" *ngIf="getPhotoCoordinates(post) as coords">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <polygon points="3 11 22 2 13 21 11 13 3 11" />
                      </svg>
                      <span>{{ coords }}</span>
                    </div>
                  </div>
                </div>

                <!-- ── WAYPOINT CARD ── -->
                <div class="waypoint-card" *ngIf="shouldShowWaypointPost(post) && !isTextPost(post) && !isPhotoPost(post)">
                  <!-- Author row -->
                  <div class="card-header author-header">
                    <div class="waypoint-headline-row">
                      <img
                        *ngIf="post.source_profile?.image_url"
                        [src]="post.source_profile.image_url"
                        class="post-avatar"
                      />
                      <div
                        *ngIf="!post.source_profile?.image_url"
                        class="post-avatar post-avatar-initials"
                      >
                        {{ getInitials(post.source_profile?.name) }}
                      </div>
                      <div class="headline-info">
                        <span class="author-name">{{
                          post.source_profile?.name
                        }}</span>
                        <div class="time-text">
                          {{ getRelativeTime(post.audit_data?.create_ts) }}
                        </div>
                      </div>
                    </div>
                    <span
                      class="wp-privacy-badge"
                      *ngIf="post.waypoint_details?.privacy === 'custom'"
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="14"
                        height="14"
                      >
                        <path
                          d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                        />
                      </svg>
                      Custom
                    </span>
                  </div>

                  <div class="divider"></div>

              

                  <!-- 50/50: stats left, map right -->
                  <div class="wp-card-layout" [class.no-map]="!hasCoordinates(post.waypoint_details?.position)">
                    <div class="wp-content" [style.max-width]="hasCoordinates(post.waypoint_details?.position) ? null : '100%'">
                       <!-- Waypoint type -->
                  <div class="waypoint-title-row" [class.title-padding]="!post.waypoint_details?.description">
                    <div class="waypoint-icon-wrap">
                      <img
                        [src]="getWaypointIcon(post.waypoint_details)"
                        class="waypoint-icon"
                      />
                    </div>
                    <span class="wp-name">{{
                      getWaypointDisplayName(post.waypoint_details)
                    }}</span>
                    <span
                        class="fish-qty-badge"
                        *ngIf="getFishQuantityBadge(post.waypoint_details) as qty"
                        >{{
                          qty
                         
                        }}</span
                      >
                  </div>

                  <p class="post-description" *ngIf="post.waypoint_details?.description">
                    {{
                      post.waypoint_details?.description 
                    }}
                  </p>
                      <!-- Location (fix 3: correct coord format via updated formatCoordinate) -->
                      <div class="location-box" *ngIf="hasCoordinates(post.waypoint_details?.position)">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          style="opacity: 0.7; flex-shrink: 0"
                        >
                          <polygon points="3 11 22 2 13 21 11 13 3 11" />
                        </svg>
                        <span class="coords">{{
                          getFullCoordinates(post.waypoint_details?.position)
                        }}</span>
                      </div>
                      <div class="wp-stats-grid" *ngIf="hasObservationSummary(post.waypoint_details)">
                        <div class="wp-stat-cell">
                          <span class="wsc-label">Speed</span>
                          <span class="wsc-val">{{
                            post.waypoint_details?.observation_summary?.sog !=
                            null
                              ? (post.waypoint_details.observation_summary.sog
                                  | number: "1.0-1") + " kts"
                              : "N/A"
                          }}</span>
                          
                        </div>
                        <div class="wp-stat-cell">
                          <span class="wsc-label">Heading</span>
                          <span class="wsc-val">{{
                            post.waypoint_details?.observation_summary?.cog !=
                            null
                              ? (post.waypoint_details.observation_summary.cog
                                  | number: "1.0-0") + "°"
                              : "N/A"
                          }}</span>
                          
                        </div>
                        <div class="wp-stat-cell">
                          <span class="wsc-label">Water Temp</span>
                          <span class="wsc-val">{{
                            post.waypoint_details?.observation_summary?.temp !=
                            null
                              ? (post.waypoint_details.observation_summary.temp
                                  | number: "1.0-1") + "°F"
                              : "N/A"
                          }}</span>
                          
                        </div>
                        <div class="wp-stat-cell">
                          <span class="wsc-label">Depth</span>
                          <span class="wsc-val">{{
                            post.waypoint_details?.observation_summary?.depth !=
                            null
                              ? (post.waypoint_details.observation_summary.depth
                                  | number: "1.0-1") + " ft"
                              : "N/A"
                          }}</span>
                          
                        </div>
                        <div class="wp-stat-cell">
                           <span class="wsc-label">Air Temp</span>
                          <span class="wsc-val">{{
                            post.waypoint_details?.observation_summary
                              ?.air_temperature != null
                              ? (post.waypoint_details.observation_summary
                                  .air_temperature | number: "1.0-1") + "°F"
                              : "N/A"
                          }}</span>
                         
                        </div>
                        <div class="wp-stat-cell">
                           <span class="wsc-label">Wind Speed</span>
                          <span class="wsc-val">{{
                            post.waypoint_details?.observation_summary
                              ?.wind_speed != null
                              ? (post.waypoint_details.observation_summary
                                  .wind_speed | number: "1.0-1") + " kts"
                              : "N/A"
                          }}</span>
                         
                        </div>
                      </div>
                    </div>
                    <div class="wp-map-container" *ngIf="hasCoordinates(post.waypoint_details?.position)">
                      <img
                        class="static-map"
                        [src]="getStaticMapUrl(post.waypoint_details)"
                        alt="map"
                      />
                      <div class="wp-pin-overlay">
                        <img [src]="getWaypointPinIcon(post.waypoint_details)" />
                      </div>
                    </div>
                  </div>
                  <!-- Attached Images (if any) -->
                  <div class="post-media" *ngIf="getPostImages(post).length > 0" style="margin-top: 12px; display: flex; gap: 8px; flex-wrap: wrap;">
                    <img
                      *ngFor="let imgUrl of getPostImages(post)"
                      [src]="imgUrl"
                      alt="Post photo"
                      style="max-height: 200px; border-radius: 8px; object-fit: cover; max-width: 100%;"
                    />
                  </div>
                  <!-- Waypoint Card Action Footer -->
                  <div class="divider interaction-divider"></div>
                  <div (click)="$event.stopPropagation()">
                    <app-post-interaction-bar
                      [postId]="post._id || post.id"
                      postType="waypoint"
                      [initialReactions]="post.reactions"
                      [initialCommentsCount]="
                        post.comments_count ||
                        post.comment_count ||
                        post.reactions?.comment_count ||
                        post.interactions?.comment_count ||
                        0
                      "
                      [enableInteractions]="true"
                    >
                      <ng-container
                        *ngIf="canEditPost(post); else sharedWaypointAction"
                      >
                        <button
                          class="action-btn"
                          title="Edit waypoint"
                          (click)="
                            $event.stopPropagation(); openWaypointDetail(post)
                          "
                        >
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path
                              d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                            />
                            <path
                              d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                            />
                          </svg>
                        </button>
                        <button
                          class="action-btn send-btn"
                          title="Send waypoint"
                          (click)="
                            $event.stopPropagation(); openSendTrip(post, $event)
                          "
                        >
                          <img
                            src="assets/common_icons/send_trip.svg"
                            width="19"
                            height="14"
                            alt="Send waypoint"
                          />
                        </button>
                        <button
                          class="action-btn"
                          title="Share waypoint"
                          (click)="
                            $event.stopPropagation(); shareTrip(post, $event)
                          "
                        >
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path
                              d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
                            />
                            <polyline points="16 6 12 2 8 6" />
                            <line x1="12" y1="2" x2="12" y2="15" />
                          </svg>
                        </button>
                      </ng-container>
                      <ng-template #sharedWaypointAction>
                        <button
                          class="action-btn"
                          title="Open waypoint"
                          (click)="openSharedWaypointDetail(post, $event)"
                        >
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <line x1="7" y1="17" x2="17" y2="7" />
                            <polyline points="7 7 17 7 17 17" />
                          </svg>
                        </button>
                      </ng-template>
                    </app-post-interaction-bar>
                  </div>
                  <!-- <div class="card-footer">

                
                </div> -->
                </div>

                <!-- ── TRIP CARD ── -->
                <div
                  class="feed-item-card trips"
                  *ngIf="shouldShowTripPost(post)"
                >
                  <!-- Header: Avatar + Name + Badges -->
                  <div class="card-header">
                    <img
                      *ngIf="post.source_profile?.image_url"
                      [src]="post.source_profile.image_url"
                      class="avatar"
                    />
                    <div
                      *ngIf="!post.source_profile?.image_url"
                      class="avatar avatar-initials"
                    >
                      {{ getInitials(post.source_profile?.name) }}
                    </div>
                    <div class="header-text">
                      <span class="user-name">{{
                        post.source_profile?.name
                      }}</span>
                      <span class="time-text">{{
                        getRelativeTime(post.audit_data?.create_ts)
                      }}</span>
                    </div>
                    <!-- Badge order: SHARE STATUS first, then TRIP STATUS.
                         That is the order everywhere else — the Watch tab renders
                         `.privacy-badge` / `.shared-badge` and then the
                         `tripStatePill` template, and the app's TripCard puts the
                         PrivacyBadge on the author row with the TripStatusBadge
                         after it. Fleet details was the only screen that emitted
                         them the other way round ("Completed" then "Shared"). -->
                    <div class="header-badges">
  <!-- Own post: show actual privacy badge -->
  <div
    class="privacy-badge"
    *ngIf="canEditPost(post)"
    [ngClass]="post.trip_details?.privacy || 'private'"
  >
    <svg
      *ngIf="post.trip_details?.privacy === 'public'"
      viewBox="0 0 24 24"
      fill="none"
      width="14"
      height="14"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="9"></circle>
      <path d="M3.6 9h16.8"></path>
      <path d="M3.6 15h16.8"></path>
      <path d="M12 3c2.2 2.3 3.4 5.5 3.4 9S14.2 18.7 12 21"></path>
      <path d="M12 3c-2.2 2.3-3.4 5.5-3.4 9s1.2 6.7 3.4 9"></path>
    </svg>

    <svg
      *ngIf="post.trip_details?.privacy === 'private' || !post.trip_details?.privacy"
      viewBox="0 0 24 24"
      fill="none"
      width="14"
      height="14"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="5" y="10" width="14" height="10" rx="2"></rect>
      <path d="M8 10V7.8C8 5.7 9.8 4 12 4s4 1.7 4 3.8V10"></path>
      <circle cx="12" cy="15" r="1.2" fill="currentColor" stroke="none"></circle>
    </svg>

    <svg
      *ngIf="post.trip_details?.privacy === 'custom'"
      viewBox="0 0 24 24"
      fill="none"
      width="14"
      height="14"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="9" cy="9" r="2.5"></circle>
      <circle cx="16.5" cy="8" r="2"></circle>
      <path d="M5.5 18.5c.6-2.4 2.4-3.8 5-3.8s4.4 1.4 5 3.8"></path>
      <path d="M15 15.2c1.7.1 2.9 1.1 3.5 3.3"></path>
    </svg>

    <span>{{ post.trip_details?.privacy | titlecase }}</span>
  </div>

  <!-- Someone else's post: show Shared badge -->
  <div class="privacy-badge custom" *ngIf="!canEditPost(post)">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      width="14"
      height="14"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="9" cy="9" r="2.5"></circle>
      <circle cx="16.5" cy="8" r="2"></circle>
      <path d="M5.5 18.5c.6-2.4 2.4-3.8 5-3.8s4.4 1.4 5 3.8"></path>
      <path d="M15 15.2c1.7.1 2.9 1.1 3.5 3.3"></path>
    </svg>
    <span>Shared</span>
  </div>

  <!-- Trip status pill — last, so it reads "Shared · Complete" like the rest of the app. -->
  <div
    class="state-pill"
    [ngClass]="normalizeTripState(post.trip_details?.trip_state)"
  >
    <svg
      *ngIf="normalizeTripState(post.trip_details?.trip_state) === 'complete'"
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
    <svg *ngIf="(post.trip_details?.trip_state) === 'in_progress'" width="12" height="12"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                    stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
    <span>{{
      normalizeTripState(post.trip_details?.trip_state) === "complete"
        ? "Complete"
        : getTripStateLabel(post.trip_details?.trip_state)
    }}</span>
  </div>
</div>
                  </div>

                  <div class="divider"></div>

                  <!-- Card body -->
                  <div
                    class="card-body"
                    (click)="canEditPost(post) ? openTripDetail(post) : null"
                  >
                    <div class="trip-card-layout">
                      <!-- LEFT: content -->
                      <div class="trip-content">
                        <span class="headline">{{
                          getTripDisplayName(post)
                        }}</span>
                        <div
                          class="description-wrapper"
                          *ngIf="post.trip_details?.description?.trim()"
                        >
                          <p class="description">
                            {{ post.trip_details.description }}
                          </p>
                          <span
                            class="desc-tooltip"
                            *ngIf="
                              post.trip_details.description?.trim()?.split(' ')
                                ?.length > 10
                            "
                            >{{ post.trip_details.description }}</span
                          >
                        </div>

                        <!-- Duration / Distance / Dates -->
                        <div class="trip-stats-bar">
                          <div class="tsb-col">
                            <span class="tsb-label">
                              <img
                                src="assets/common_icons/watch_duration.svg"
                                class="tsb-icon"
                              />
                              Duration
                            </span>
                            <span class="tsb-val">{{
                              calculateDuration(
                                post.trip_details?.start_time,
                                post.trip_details?.end_time,
                                post.trip_details?.trip_state,
                                post.trip_details?.metrics?.duration_hours
                              )
                            }}</span>
                          </div>
                          <div class="tsb-col">
                            <span class="tsb-label">
                              <img
                                src="assets/common_icons/watch_distance.svg"
                                class="tsb-icon"
                              />
                              Distance
                            </span>
                            <span class="tsb-val">{{
                              getDistance(
                                post.trip_details?.metrics?.distance_covered
                              )
                            }}</span>
                          </div>
                          <div class="tsb-col">
                            <span class="tsb-label">
                              <img
                                src="assets/common_icons/watch_dates.svg"
                                class="tsb-icon"
                              />
                              Date
                            </span>
                            <span class="tsb-val">{{
                              formatDateRange(post.trip_details?.start_time)
                            }}</span>
                          </div>
                        </div>

                        <!-- Waypoints bar -->
                        <div class="waypoints-summary-bar">
                          <span class="wp-text">
                            Waypoints:
                            <ng-container
                              *ngIf="
                                !isVisibleWaypointCountLoading(post);
                                else fleetTripWaypointCountLoading
                              "
                            >
                              {{ getVisibleWaypointCount(post) }}
                            </ng-container>
                          </span>
                          <ng-template #fleetTripWaypointCountLoading>
                            <span
                              class="wp-count-loader"
                              aria-label="Loading waypoint count"
                            ></span>
                          </ng-template>
                           <div class="wp-icons">
                        <div class="w-icon bg-cyan"><img src="assets/common_icons/waypoint_pin_white.svg" width="14"
                            height="14" /></div>
                        <div class="w-icon bg-orange"><img src="assets/common_icons/waypoint_marker_circle.svg"
                            width="14" height="14" /></div>
                        <div class="w-icon bg-purple"><img src="assets/common_icons/waypoint_anchor.svg" width="14"
                            height="14" /></div>
                      </div>
                        </div>

                        <!-- Conditions -->
                        <div class="conditions-section">
                          <div class="conditions-row-3">
                            <div class="cond-card">
                              <span class="cond-val">{{
                                post.trip_details?.observation_summary
                                  ?.air_temp_f != null
                                  ? (post.trip_details.observation_summary
                                      .air_temp_f | number: "1.0-1") + "°F"
                                  : "--"
                              }}</span>
                              <span class="cond-label">Air Temp</span>
                            </div>
                            <div class="cond-card">
                              <span class="cond-val">{{
                                post.trip_details?.observation_summary
                                  ?.air_pressure_inhg != null
                                  ? (post.trip_details.observation_summary
                                      .air_pressure_inhg | number: "1.0-0") +
                                    " inHg"
                                  : "--"
                              }}</span>
                              <span class="cond-label">Air Pressure</span>
                            </div>
                            <div class="cond-card">
                              <span class="cond-val">{{
                                getMoonIllumDisplay(
                                  post.trip_details?.observation_summary
                                    ?.moon_illum_fraction
                                )
                              }}</span>
                              <span class="cond-label">Moon Illum.</span>
                            </div>
                          </div>
                          <!-- Expanded rows -->
                          <div
                            class="conditions-row-3"
                            *ngIf="isTripPostExpanded(post._id || post.id)"
                          >
                            <div class="cond-card">
                              <span class="cond-val">{{
                                cleanTimeValue(
                                  post.trip_details?.observation_summary
                                    ?.sunrise_local
                                )
                              }}</span>
                              <span class="cond-label">Sunrise</span>
                            </div>
                            <div class="cond-card">
                              <span class="cond-val">{{
                                cleanTimeValue(
                                  post.trip_details?.observation_summary
                                    ?.sunset_local
                                )
                              }}</span>
                              <span class="cond-label">Sunset</span>
                            </div>
                            <div class="cond-card">
                              <span class="cond-val">{{
                                post.trip_details?.observation_summary
                                  ?.moon_phase || "--"
                              }}</span>
                              <span class="cond-label">Moon Phase</span>
                            </div>
                          </div>
                          <div
                            class="vessel-row"
                            *ngIf="
                              isTripPostExpanded(post._id || post.id) &&
                              (post.trip_details?.vessel_name ||
                                post.trip_details?.vessel_ref?.name)
                            "
                          >
                            <img
                              src="assets/home/profile/boaticon.svg"
                              width="14"
                              height="14"
                              style="opacity: 0.5; flex-shrink: 0"
                            />
                            <span>{{
                              post.trip_details?.vessel_name ||
                                post.trip_details?.vessel_ref?.name
                            }}</span>
                          </div>
                          <!-- Show more / Show less -->
                          <button
                            class="show-more-btn"
                            (click)="
                              toggleTripPostExpanded(
                                post._id || post.id,
                                $event
                              )
                            "
                          >
                            {{
                              isTripPostExpanded(post._id || post.id)
                                ? "Show less"
                                : "Show more"
                            }}
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <polyline
                                *ngIf="isTripPostExpanded(post._id || post.id)"
                                points="18 15 12 9 6 15"
                              ></polyline>
                              <polyline
                                *ngIf="!isTripPostExpanded(post._id || post.id)"
                                points="6 9 12 15 18 9"
                              ></polyline>
                            </svg>
                          </button>
                        </div>
                      </div>

                      <!-- RIGHT: map -->
                      <div class="trip-map-container">
                        <img
                          *ngIf="getTripMapUrl(post.trip_details)"
                          [src]="getTripMapUrl(post.trip_details)"
                          class="static-map"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Action footer -->
                  <!-- <div class="card-footer"> -->
                  <app-post-interaction-bar
                    [postId]="post._id || post.id"
                    postType="trips"
                    [initialReactions]="post.reactions"
                    [initialCommentsCount]="
                      post.comments_count ||
                      post.comment_count ||
                      post.reactions?.comment_count ||
                      post.interactions?.comment_count ||
                      0
                    "
                    [enableInteractions]="true"
                  >
                    <!-- Fleet owner/admin or post creator: edit + send + share -->
                    <ng-container *ngIf="canEditPost(post)">
                      <button
                        class="action-btn"
                        title="Edit trip"
                        (click)="openTripDetail(post)"
                      >
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path
                            d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                          />
                          <path
                            d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                          />
                        </svg>
                      </button>
                      <button
                        class="action-btn send-btn"
                        title="Send trip"
                        (click)="openSendTrip(post, $event)"
                      >
                        <img
                          src="assets/common_icons/send_trip.svg"
                          width="19"
                          height="14"
                          alt="Send trip"
                        />
                      </button>
                      <button
                        class="action-btn"
                        title="Share trip"
                        (click)="shareTrip(post, $event)"
                      >
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                          <polyline points="16 6 12 2 8 6" />
                          <line x1="12" y1="2" x2="12" y2="15" />
                        </svg>
                      </button>
                    </ng-container>
                    <!-- Not post creator: view only -->
                    <ng-container *ngIf="!canEditPost(post)">
                      <button
                        class="action-btn"
                        title="Open trip"
                        (click)="openSharedTripDetail(post, $event)"
                      >
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <line x1="7" y1="17" x2="17" y2="7" />
                          <polyline points="7 7 17 7 17 17" />
                        </svg>
                      </button>
                    </ng-container>
                  </app-post-interaction-bar>

                  <!-- </div> -->
                </div>
              </ng-container>
              </ng-container>

              <div
                *ngIf="!loadingPosts && visiblePosts.length === 0"
                class="no-posts"
              >
                No shared posts yet.
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <!-- Members list. Owners/admins get the manage view; everyone else gets the
         read-only list with an Owner/Admin badge (mirrors the app, where a
         plain member can browse the roster but not manage it). -->
    <app-manage-members
      *ngIf="showManageMembers"
      [fleet]="fleet"
      [readOnly]="!canManageMembers"
      (close)="closeManageMembers()"
      (memberSelected)="onMemberSelected($event)"
    ></app-manage-members>

    <!-- Edit Fleet Popup -->
    <app-create-fleet
      *ngIf="showEditFleet"
      [editFleet]="fleet"
      (close)="closeEditFleet()"
      (saved)="closeEditFleet()"
    ></app-create-fleet>
  </div>
</div>

<!-- ── Send Trip Overlay ── -->
<div
  class="bottom-sheet-overlay send-trip-overlay"
  *ngIf="isSendTripOpen"
  (click)="closeSendTrip()"
>
  <div class="bottom-sheet send-trip-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="drag-handle"></div>
      <div class="header-actions">
        <button class="collapse-btn" (click)="closeSendTrip()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="#1c1c1e" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <h2 class="title">Send Trip</h2>
        <button class="save-btn" (click)="confirmSendTrip()">
          <img src="assets/common_icons/blueRight_ticket.svg" />
        </button>
      </div>
    </div>
    <div class="content-scrollable">
      <p class="send-trip-subtitle">
        Send Trip "{{
          activeSendTrip?.trip_details?.name || activeSendTrip?.name
        }}" to Fleets or Dockmates
      </p>
      <div class="search-box">
        <img class="search-icon" src="assets/home/profile/searchicon.svg" />
        <input
          type="text"
          placeholder="Search fleets or dockmates"
          [(ngModel)]="sendTripSearchQuery"
        />
      </div>
      <!-- Fleets -->
      <div class="selection-section" *ngIf="filteredSendFleets.length > 0">
        <label>Fleets</label>
        <div class="item-list">
          <div
            class="list-item"
            *ngFor="let f of filteredSendFleets"
            [class.already-shared]="f.alreadyShared"
          >
            <div class="item-info">
              <div
                class="checkbox"
                [class.checked]="f.sendSelected || f.alreadyShared"
                [class.disabled]="f.alreadyShared"
                (click)="!f.alreadyShared && (f.sendSelected = !f.sendSelected)"
              ></div>
              <img
                *ngIf="f.logo_url || f.image_url || f.image"
                [src]="f.logo_url || f.image_url || f.image"
                class="avatar"
                [class.muted]="f.alreadyShared"
              />
              <div
                *ngIf="!f.logo_url && !f.image_url && !f.image"
                class="avatar-fallback"
                [class.muted]="f.alreadyShared"
              >
                {{ getInitials(f.name) }}
              </div>
              <div class="info-text">
                <span class="name" [class.muted-text]="f.alreadyShared">{{
                  f.name
                }}</span>
                <span class="meta already-shared-label" *ngIf="f.alreadyShared"
                  >Already shared</span
                >
                <span class="meta" *ngIf="!f.alreadyShared"
                  >{{ f.members_count || 0 }}
                  {{ (f.members_count || 0) <= 1 ? "member" : "members" }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Dockmates -->
      <div class="selection-section" *ngIf="filteredSendDockmates.length > 0">
        <label>Dockmates</label>
        <div class="item-list">
          <div
            class="list-item"
            *ngFor="let mate of filteredSendDockmates"
            [class.already-shared]="mate.alreadyShared"
          >
            <div class="item-info">
              <div
                class="checkbox"
                [class.checked]="mate.sendSelected || mate.alreadyShared"
                [class.disabled]="mate.alreadyShared"
                (click)="
                  !mate.alreadyShared &&
                    (mate.sendSelected = !mate.sendSelected)
                "
              ></div>
              <img
                *ngIf="
                  mate.image_url || mate.image || mate.owner_ref?.image_url
                "
                [src]="
                  mate.image_url || mate.image || mate.owner_ref?.image_url
                "
                class="avatar"
                [class.muted]="mate.alreadyShared"
              />
              <div
                *ngIf="
                  !mate.image_url && !mate.image && !mate.owner_ref?.image_url
                "
                class="avatar-fallback"
                [class.muted]="mate.alreadyShared"
              >
                {{ getInitials(mate.name) }}
              </div>
              <div class="info-text">
                <span class="name" [class.muted-text]="mate.alreadyShared">{{
                  mate.name
                }}</span>
                <span
                  class="meta already-shared-label"
                  *ngIf="mate.alreadyShared"
                  >Already shared</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          filteredSendFleets.length === 0 && filteredSendDockmates.length === 0
        "
        class="no-results"
      >
        No fleets or dockmates found.
      </div>
    </div>
  </div>
</div>

<!-- Trip Detail (same as Watch) -->
<app-trips
  *ngIf="fleetTripId"
  [initialTripId]="fleetTripId"
  [embeddedMode]="true"
  (overlayClosed)="fleetTripId = null"
>
</app-trips>

<!-- Waypoint Detail inline (fleet shared posts) -->
<app-waypoints
  *ngIf="fleetWaypointId"
  [initialWaypointId]="fleetWaypointId"
  [preloadedWaypoint]="selectedFleetWaypointData"
  [hideWaypointList]="true"
  [directMode]="true"
  (closed)="fleetWaypointId = null; selectedFleetWaypointData = null"
>
</app-waypoints>

<!-- Leave Fleet Confirm Modal -->
<div
  class="leave-confirm-overlay"
  *ngIf="showLeaveConfirm"
  (click)="showLeaveConfirm = false"
>
  <div class="leave-confirm-modal" (click)="$event.stopPropagation()">
    <h3 class="modal-title">Leave Fleet</h3>
    <p class="modal-message">Are you sure you want to leave this fleet?</p>
    <div class="modal-actions">
      <button class="modal-cancel-btn" (click)="showLeaveConfirm = false" [disabled]="requesting">
        Cancel
      </button>
      <button class="modal-leave-btn" (click)="confirmLeave()" [disabled]="requesting">
        <span *ngIf="requesting" class="btn-spinner"></span>
        <span *ngIf="!requesting">Leave</span>
      </button>
    </div>
  </div>
</div>

<!-- <app-restrictive-acknowledgement-dialog
  *ngIf="showRestrictionRulesDialog"
  mode="rules"
  (closed)="showRestrictionRulesDialog = false"
  (agreed)="showRestrictionRulesDialog = false"
  (disagreed)="showRestrictionRulesDialog = false"
>
</app-restrictive-acknowledgement-dialog> -->

<!-- Always-present file input so we can trigger it before sheet opens -->
<input
  #shareImgInput
  type="file"
  accept="image/*"
  style="display: none"
  (change)="onShareImageSelected($event)"
/>

<!-- Share Image Sheet -->
<div
  class="bottom-sheet-overlay share-image-overlay"
  *ngIf="shareImageSheetOpen"
  (click)="shareImageStep !== 'generating' && closeShareImageSheet()"
>
  <div class="share-image-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="drag-handle"></div>
      <div class="header-actions">
        <button
          class="collapse-btn"
          (click)="shareImageGoBack()"
          [disabled]="shareImageStep === 'generating'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#1c1c1e"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h2 class="title">
          <ng-container *ngIf="shareImageStep === 'choose'"
            >Share Post</ng-container
          >
          <ng-container *ngIf="shareImageStep !== 'choose'"
            >Share Card</ng-container
          >
        </h2>
        <button
          class="save-btn si-header-share"
          *ngIf="shareImageStep === 'generated'"
          (click)="confirmShareCard()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#007aff"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
            <polyline points="16 6 12 2 8 6" />
            <line x1="12" y1="2" x2="12" y2="15" />
          </svg>
        </button>
        <div *ngIf="shareImageStep !== 'generated'" style="width: 32px"></div>
      </div>
    </div>

    <div class="content-scrollable si-content">
      <!-- Step 1: Choose photo -->
      <ng-container *ngIf="shareImageStep === 'choose'">
        <p class="si-trip-name">
          {{
            shareImagePost?.trip_details?.name ||
              shareImagePost?.waypoint_details?.name
          }}
        </p>
        <label class="si-choose-area">
          <input
            type="file"
            accept="image/*"
            style="display: none"
            (change)="onShareImageSelected($event)"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="52"
            height="52"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#9ca3af"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <circle cx="8.5" cy="8.5" r="1.5"></circle>
            <polyline points="21 15 16 10 5 21"></polyline>
          </svg>
          <span class="si-choose-label">Choose from Photos</span>
          <span class="si-choose-sub"
            >Tap to select an image from your device</span
          >
        </label>
      </ng-container>

      <!-- Step 2: Caption + photo preview -->
      <ng-container *ngIf="shareImageStep === 'caption'">
        <p class="si-trip-name">
          {{
            shareImagePost?.trip_details?.name ||
              shareImagePost?.waypoint_details?.name
          }}
        </p>
        <div class="si-photo-preview">
          <img [src]="shareImagePreviewUrl" class="si-preview-img" />
        </div>
        <button
          class="si-replace-btn"
          type="button"
          (click)="shareImgInput.click()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
            ></path>
            <circle cx="12" cy="13" r="4"></circle>
          </svg>
          Replace Photo
        </button>
        <div class="si-caption-group">
          <label class="si-label">Write your caption</label>
          <p class="si-caption-subtitle">
            Appears on the share card image above with the typed caption along
            with trip main information.
          </p>
          <textarea
            class="si-caption"
            [(ngModel)]="shareImageCaption"
            placeholder="Add a description"
            rows="4"
            maxlength="250"
          ></textarea>
          <div class="si-caption-footer">
            <span></span>
            <span class="si-char-count"
              >{{ shareImageCaption.length }}/250</span
            >
          </div>
          <span class="si-status error" *ngIf="shareImagePreparationError">{{
            shareImagePreparationError
          }}</span>
        </div>
        <button class="si-generate-btn" (click)="generateShareCard()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
          </svg>
          Generate
        </button>
      </ng-container>

      <!-- Step 3: Generating spinner -->
      <ng-container *ngIf="shareImageStep === 'generating'">
        <div class="si-generating">
          <span class="si-spinner-dark"></span>
          <p class="si-generating-text">Creating your share card…</p>
        </div>
      </ng-container>

      <!-- Step 4: Generated -->
      <ng-container *ngIf="shareImageStep === 'generated'">
        <h3 class="si-generated-heading">Here is your share card 🎉</h3>
        <div class="si-generated-preview">
          <img
            [src]="shareImageGeneratedPreviewUrl"
            class="si-generated-img"
            alt="Share card preview"
          />
        </div>
        <button class="si-share-btn" (click)="confirmShareCard()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
            <polyline points="16 6 12 2 8 6" />
            <line x1="12" y1="2" x2="12" y2="15" />
          </svg>
          Share via...
        </button>
      </ng-container>
    </div>
  </div>
</div>

<!-- ── Image Lightbox Modal ── -->
<app-image-lightbox
  *ngIf="lightboxOpen"
  [images]="lightboxImages"
  [index]="lightboxStartIndex"
  (closed)="closeLightbox()"
></app-image-lightbox>
